module.exports = __webpack_public_path__ + "static/eplus420-96203d525fccc161f5fd86b4db553a73.png";